module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "words-query"
  }, [_c('form', {
    attrs: {
      "action": "#"
    }
  }, [_vm._l((_vm.categories), function(category, index) {
    return _c('div', [_c('label', [_vm._v(_vm._s(_vm.translateColumn(category.columnName)))]), _vm._v(" "), _c('MultiSelect', {
      attrs: {
        "allOption": true,
        "many": "selected",
        "options": category.options,
        "value": _vm.selectedCategories[index].options
      },
      on: {
        "update:value": function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          return _vm.updateCategories.apply(void 0, [ index ].concat( args ));
    }
      }
    })], 1)
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.i18n().columns))]), _vm._v(" "), _c('MultiSelect', {
    attrs: {
      "options": _vm.columns,
      "value": _vm.wordsColumns,
      "display": function (c) { return _vm.translateColumn(c); }
    },
    on: {
      "update:value": function($event) {
        _vm.wordsColumns = $event
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "min-words"
    }
  }, [_vm._v(_vm._s(_vm.i18n().number))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "words-number"
    }
  }, [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.minWords),
      expression: "minWords"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "pattern": "-?[0-9]*(\\.[0-9]+)?",
      "id": "min-words"
    },
    domProps: {
      "value": (_vm.minWords)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.minWords = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "min-words"
    }
  }, [_vm._v(_vm._s(_vm.i18n.min))]), _vm._v(" "), _c('span', {
    staticClass: "mdl-textfield__error"
  }, [_vm._v(_vm._s(_vm.i18n().isNotANumber))])]), _vm._v(" "), _c('span', {
    staticClass: "range-to"
  }, [_vm._v("-")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.maxWords),
      expression: "maxWords"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "pattern": "-?[0-9]*(\\.[0-9]+)?",
      "id": "max-words"
    },
    domProps: {
      "value": (_vm.maxWords)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.maxWords = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "max-words"
    }
  }, [_vm._v(_vm._s(_vm.i18n.max))]), _vm._v(" "), _c('span', {
    staticClass: "mdl-textfield__error"
  }, [_vm._v(_vm._s(_vm.i18n().isNotANumber))])])]), _vm._v(" "), _c('div', {
    staticClass: "check-box",
    on: {
      "click": _vm.toggleSpecialCharacters
    }
  }, [_c('span', [(_vm.ignoreSpecialCharacters) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("check_box")]) : _vm._e(), _vm._v(" "), (!_vm.ignoreSpecialCharacters) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("check_box_outline_blank")]) : _vm._e()]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.i18n().ignoreSpecial))])]), _vm._v(" "), _c('div', {
    staticClass: "check-box",
    on: {
      "click": _vm.toggleIgnoreCase
    }
  }, [_c('span', [(_vm.ignoreCase) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("check_box")]) : _vm._e(), _vm._v(" "), (!_vm.ignoreCase) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("check_box_outline_blank")]) : _vm._e()]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.i18n().ignoreCase))])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a42a45d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/words/WordsQuery.vue
// module id = 431
// module chunks = 0